const getCurrencySymbol = (
  currencyCode: string,
  locale: string = 'en-US',
): string => {
  try {
    const formatted = (0).toLocaleString(locale, {
      style: 'currency',
      currency: currencyCode as Intl.NumberFormatOptions['currency'],
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    // Extract currency symbol by removing digits, commas, dots, and spaces
    const symbol = formatted.replace(/[\d\s.,]/g, '').trim();
    return symbol;
  } catch (error) {
    console.warn(`Invalid currency code or locale: ${currencyCode}, ${locale}`);
    return currencyCode;
  }
};

export default getCurrencySymbol;
